export default __webpack_public_path__ + "static/media/Financial-Data-Services.14ff5874.png";